<template>
  <div class="font-weight-light text-darken-2 pl-0 pt-10">
    <v-container class="sidebarContainer pt-2 pb-5">
      <a href="https://sigflo.com" style="text-decoration: none">
        <v-img width="160" src="@/assets/images/sigfloLogoWhite.svg" />
      </a>
    </v-container>
    <!-- Project List -->
    <v-list class="pt-0">
      <v-subheader class="link white--text sigfloBody400" @click="navToProjectStart"
        ><v-icon class="mr-3 lightPurpleText">mdi-folder-outline</v-icon>Projects</v-subheader
      >
      <v-list-item-group class="pl-1">
        <v-list-item
          v-for="project in configurator.projects"
          :key="project.id"
          @click="openProject(project.id)"
          class="ml-4 menuFadeOut"
          active-class="activeProject"
        >
          <v-list-item-content class="lightPurpleText sigfloBodySmall">
            <v-list-item-title>{{ project.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :input-value="true" @click="openProject" class="mt-2 pl-0" color="#401881">
          <v-list-item-content class="sigfloBodySmall lightPurpleText purpleListHighlight pl-1">
            <v-list-item-title>
              <v-icon color="grey" class="mr-2 mb-1" dark> mdi-plus-circle-outline </v-icon>Start New
              Project</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-spacer />
    <!-- Bottom Container-->
    <v-list dense class="bottomContainer authContainer text-capitalize pb-0">
      <v-list-item v-if="app.user && app.user.isGuest"
        ><v-icon class="lightPurpleText">mdi-account-plus</v-icon
        ><v-btn text class="lightPurpleText sigfloBodySmall text-capitalize" @click="showCreateAccountDialog"
          >Create account</v-btn
        ></v-list-item
      >
      <v-list-item v-if="app.user && app.user.isGuest"
        ><v-icon class="lightPurpleText">mdi-keyboard</v-icon
        ><v-btn text @click="showLoginDialog" class="lightPurpleText sigfloBodySmall text-capitalize"
          >Sign in</v-btn
        ></v-list-item
      >
      <v-list-item v-if="app.user && app.user.isUser" class="lightPurpleText"
        ><v-icon class="lightPurpleText">mdi-exit-to-app</v-icon
        ><v-btn text class="lightPurpleText sigfloBodySmall text-capitalize" @click="logout"
          >Log Out</v-btn
        ></v-list-item
      >
      <v-menu open-on-hover top right v-model="accountMenu" offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item
            v-bind="attrs"
            v-on="on"
            two-line
            class="white--text pl-2 accountListItem"
            @click="handleAccountClick"
          >
            <v-avatar color="#a67ee7" width="48" height="48" class="mr-2 ml-1" dark>
              <v-icon dark>mdi-account</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="white--text sigfloBody400"
                >{{ app.user.firstName }} {{ app.user.lastName }}</v-list-item-title
              >

              <v-list-item-subtitle class="lightPurpleText">Awesome User</v-list-item-subtitle>
            </v-list-item-content>
            <v-btn icon class="lightPurpleText"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            <div class="text-caption white--text"></div
          ></v-list-item>
        </template>
        <v-card rounded class="" v-show="app.user.isUser">
          <v-card-text>
            <v-list>
              <v-list-item-group>
                <v-list-item>
                  <v-list-item-content class="text-uppercase" @click="handleAccountClick">
                    My Account
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-list>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        search: null,
        accountMenu: null
      };
    },
    methods: {
      logout() {
        this.$store.dispatch('app/logout').then(() => {
          this.unwindStack();
          this.navToProjectPage();
        });
      },
      handleAccountClick() {
        if (this.app.user.isUser) {
          this.navToAccountPage();
        } else {
          this.showLoginDialog();
        }
      }
    },
    computed: {
      ...mapState(['app', 'navigation', 'configurator']),
      getEmail() {
        return this.app.user.email.indexOf('guest') > -1
          ? 'Guest'
          : this.app.user.email.substring(0, this.app.user.email.indexOf('@'));
      },
      projects() {
        let projectList = this.configurator.projects;
        if (!projectList.find((x) => x.id == -1)) {
          projectList.push(this.newProject);
        }

        return projectList;
      },
      currentProject: {
        get() {
          return this.configurator.currentProject?.id;
        },
        set() {}
      }
    }
  };
</script>

<style scoped>
  .activeProject {
    background-color: #401881 !important;
    color: white !important;
  }
  .accountListItem {
    background-color: #2b1056 !important;
  }
  .v-list-item__content {
    padding: 4px 0;
  }
  .v-list-item {
    min-height: 32px;
  }
  .purpleListHighlight {
    background-color: #401881 !important;
  }
  .searchField {
    color: #c4a9ef !important;
  }
  .bottomContainer {
    background-color: transparent !important;
    position: absolute;
    bottom: 0px;
    width: 100%;
    /* border-top: 1px solid #625676; */
  }
  .menuFadeOut {
    /* Container dimensions and positioning */
    width: 200px; /* Adjust width as needed */
    height: auto;
    position: relative;
    overflow: hidden; /* Hide overflow */
    text-overflow: inherit;
    /* Text properties */
    white-space: nowrap; /* Keep text in a single line */

    /* Masking to create fade effect */
    /* -webkit-mask-image: linear-gradient(to right, black 75%, transparent 100%);
    mask-image: linear-gradient(to right, black 75%, transparent 100%); */
  }
</style>
